import React from "react";
import { FaChartLine, FaTrophy, FaGlobe, FaUsers } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

const RoadmapStats = () => {
  const { t } = useLanguage();

  const statsData = [
    {
      icon: FaChartLine,
      value: "60%+",
      description: t("roadmapStats.realEstateGrowth"),
      color: "turquoise"
    },
    {
      icon: FaTrophy,
      value: "#1",
      description: t("roadmapStats.foreignInvestors"),
      color: "yellow"
    },
    {
      icon: FaGlobe,
      value: "75%",
      description: t("roadmapStats.nonOilGdp"),
      color: "turquoise"
    },
    {
      icon: FaUsers,
      value: "96M",
      description: t("roadmapStats.airportPassengers"),
      color: "yellow"
    }
  ];

  const getColorClass = (color) => {
    return color === "turquoise" ? "text-info" : "text-warning";
  };

  return (
    <section className="roadmap-stats-area pt-20 pb-80">
      <div className="container custom-container-two">
        <div className="row">
          <div className="col-lg-12">
            <div 
              className="d-flex flex-row gap-4 justify-content-center align-items-center flex-wrap"
              style={{ gap: "2rem" }}
            >
              {statsData.map((stat, index) => (
                <div
                  key={index}
                  className="roadmap-stat-card"
                  style={{
                    backgroundColor: "rgba(33, 37, 41, 0.4)",
                    borderRadius: "25px",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    minWidth: "200px",
                    flex: "1",
                    maxWidth: "250px",
                    padding: "1.5rem",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <div 
                    className="stat-icon mb-3"
                    style={{ fontSize: "1.5rem" }}
                  >
                    <stat.icon className={getColorClass(stat.color)} />
                  </div>
                  
                  <div 
                    className={`stat-value mb-2 ${getColorClass(stat.color)}`}
                    style={{ 
                      fontSize: "1.5rem", 
                      fontWeight: "bold",
                      lineHeight: "1.2"
                    }}
                  >
                    {stat.value}
                  </div>
                  
                  <div 
                    className="stat-description text-white"
                    style={{ 
                      fontSize: "0.9rem", 
                      lineHeight: "1.4",
                      textAlign: "center"
                    }}
                  >
                    {stat.description}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoadmapStats;
